module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('div', {
    staticClass: "r-List"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("账户交易明细")]), _vm._l((_vm.payList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "row1"
    }, [_c('div', {
      staticClass: "way"
    }, [_vm._v("通过" + _vm._s(item.way)), (item.type == "add") ? _c('span', [_vm._v("充值")]) : _c('span', [_vm._v("消费")])]), _c('div', {
      staticClass: "price"
    }, [_vm._v("余额"), (item.type == "add") ? _c('span', [_vm._v("加")]) : _c('span', [_vm._v("减")]), _c('span', [_vm._v("￥" + _vm._s(item.price) + "元")])])]), _c('div', {
      staticClass: "time"
    }, [_vm._v("  2015-4-4")])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "msg-wrap"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require(".././assets/yue.png")
    }
  })]), _c('div', {
    staticClass: "msg"
  }, [_c('div', {
    staticClass: "yue"
  }, [_vm._v("账户余额")]), _c('div', {
    staticClass: "num"
  }, [_vm._v("500")])]), _c('div', {
    staticClass: "recharge"
  }, [_vm._v("充值")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13653544","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yue.vue
// module id = 107
// module chunks = 0